import { element } from 'protractor';
import { TaskRoutingModule } from './../../pages/task/task-routing.module';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomerdosService } from 'src/app/services/customerdos/customerdos.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import { OrderService } from 'src/app/services/order/order.service';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { FormControl, FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { PreloadAllModules, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import Selectr from 'mobius1-selectr';

import { PhleboService } from 'src/app/services/phlebo/phlebo.service';
import { PlanService } from  'src/app/services/plan/plan.service'
import { LablocationService } from 'src/app/services/lablocation/lablocation.service';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { TaskService } from 'src/app/services/task/task.service';
import { RunnerService } from 'src/app/services/runner/runner.service';
import { RoleService } from 'src/app/services/role/role.service';
import { TourService } from 'src/app/services/tour/tour.service';
import { EnduserService } from 'src/app/services/enduser/enduser.service';
import { SalesService } from 'src/app/services/sales/sales.service';
import { multicast } from 'rxjs/operators';
import { stringify } from 'querystring';
import { info } from 'console';
declare var google: any;



@Component({
    selector: 'app-enterModal',
    templateUrl: './enterModal.component.html',
    styleUrls: ['./enterModal.component.scss']
})
export class enterModalComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    map!: google.maps.Map;
    public title: string;
    public minDate = new Date();
    public subTitle: string;
    selectorMultiple: Selectr;
    public appointmentByIdData:any=[];
    public type: string;
    public sortDirection:any;
    public data: any;
    public barcodeList:any;
    public permissionList:any=[];
    public lablocationList:any = [];
    public barcodeRunenr:any =[];
    public barcodedata: any = [];
    public patientDropdown:any = [];
    public checkedPermission:any = [];
    public visitTestsdata: any = [];
    public markavailabledata: any = [];
    public barcodedoc: any =[];
    public page: any = 1;
    public ReportTouchSubmit = false;
    public toDate:any;
    public fromDate:any
    public isLoadedTable = true;
    public isBtnLoaded = false;
    public reasonrescheduletouched = false;
    public confirmtouched = false;
    public locationTouched = false;
    public nextSaveBtnLoding = false;
    gfg1 = {hour: 15, minute: 58};
    form!: FormGroup
    public reportuploadForm!: FormGroup
    customer_id: any
    showError: boolean;
    userType: any;
    reconcile_comment: any;
    login_customer_id: any;
    public declineForm: FormGroup
    cancellForm: FormGroup
    rescheduleForm: FormGroup
    confirmForm: FormGroup
    locationForm: FormGroup
    editPhleboPlanForm:FormGroup
    canclereasonDropDown: any;
    reschedulereasonDropDown: any;
    reconsileForm: FormGroup;
    changeLocationForm!:FormGroup;
    public addlablocation:any = [];
    public permissionForRole:any = [];
    // location_addresslistForDropdown: any = [{ value: 'all', text: 'All' }];
    location_addresslistForDropdown: any = [];
    public salesRepProfileData:any= '';
    public salesRepProfileModelData:File = null;
    public masterLabLocation:any = [];
    selectedMainLab: any = null;
    defaultLabLocationId: any = null;
    mainLabListForDropdown:any = [];
    editVisitPlanForm:FormGroup
    inputtype: string;
    markCollectedForm: FormGroup;
    public collectedDate :any;
    public collectedTime :any;
    public patienlistbyid :any;
    public timelinedata :any;
    public pullreportdata :any;
    mydate: string;
    client_id:any;
    checkdate: number;
    exportFileList: any;
    Form: FormGroup;
    rosterForm: FormGroup;
    rosterFormRunner: FormGroup;
    cashDepositTo: FormGroup;
    addreportdata: FormGroup;
    roleForm : FormGroup;
    collectionForm: FormGroup;
    patientReportData:any = [];
    itdosReportData:any = [];
    patientReportData2:any = [];
    rosterTouchSubmit=false;
    phleboTouchSubmit = false;
    clientId: any=1;
    userRole: any;
    userFacility: any;
   public lablocation: any=[];
   public searchNamefilter:any;
   public orderReportList :any = [];
   public sortColumn:any;
    isDeviceService = false;
    assignTaskTouchSubmit=false;
    assignForm: FormGroup;
    tourlistForDropdown: any;
    public slotFilter: any= '';
    public slotlistForDropdown: any;
    public runnerlistForDropdown:any = [];
    public AssignRunnerForm: FormGroup;
    public assignRunnerData:any = [];
    public dateInputFormat:any =[];
    public dateFormat: any ='';
    ordertimeline = [];
    selectedVisitIds: any[] = [];
    mainLabId: number | null = null;
    // visitTestsdata: any[] = []; // Array to store test details for all selected visits
    // addlablocation: any[] = [];
    public config: any = {
        displayKey: 'text',
        placeholder: 'Select Lab Location',
        search: true,
        searchOnKey: 'text',
        noResultsFound: 'No lab location found!',
    }
    public labConfig: any = {
        displayKey: 'lab_name',  // 👈 Key to show in dropdown
        valueKey: 'id',
        placeholder: 'Select Lab',
        search: true,
        searchOnKey: 'lab_name',
        noResultsFound: 'No lab found!',
        clearOnSelection: false
    };
    allFacilityList: any[];
    locationPatientForm: FormGroup;
    constructor(
        private ngbModal: NgbActiveModal,
        private toastr: ToastrService,
        private customerdosService: CustomerdosService,
        private settingService: SettingService,
        private orderService: OrderService,
        private authService: AuthenticationService,
        public phleboService:PhleboService,
        public runnerService:RunnerService,
        public TourService:TourService,
        public planService:PlanService,
        public roleService:RoleService,
        public enduserService:EnduserService,
        public lablocationService:LablocationService,
        private formBuilder: FormBuilder,
        private router: Router,
        private modalService: NgbModal,

        public datepipe: DatePipe,
        public invoiceService : InvoiceService,
        public taskService:TaskService,
        public salesService:SalesService


    ) {
        // this.userType= this.authService.user.roles[0].user_type_id;
        this.userType= 2;
        this.login_customer_id= this.authService.user.customer_id;

    }
    ngOnInit(): void {

        this.orderService.getAllFacilities().subscribe((data) => {
        var facilityData = [];
        data.data.rows.forEach((item) => {
            facilityData.push({ value: item.id, text: item.location_name });
        });
        this.allFacilityList = facilityData;
        
        });
        this.userRole = this.authService.user.role_id;
        if (this.userRole == 32) {
            this.userFacility = this.authService.user.user_facility;
        }
        this.dateFormat = localStorage.getItem('dateFormat');
        this.dateInputFormat =localStorage.getItem('dateFormat').toUpperCase();
        this.isDeviceService = localStorage.getItem('is_device_service') == 'true' || localStorage.getItem('is_device_service') == '1';
        // console.log(this.masterLabLocation+'lablocation');
        this.setDialogProps(this.props);

        if(this.type == 'salesRepProfuileUpload'){
          this.salesRepProfileData = this.salesRepProfileData?this.salesRepProfileData:this.data.profile_pic
        }


        if(this.type =='ViewOrderTimeline'){
        this.orderService.getOrderTimeline(this.data.id).subscribe(
            (res: any) => {
                this.timelinedata = res.data;
            },
        );
        }

        if (this.type === 'ViewPhleboLocation') {
            this.orderService.getPhlebolocations(this.data.id, this.data.phlebo_id).subscribe((res: any) => {
                // if (res.success && Array.isArray(res.data)) {

                //     this.timelinedata = res.data;


                //     const points = res.data.filter(p => p.lat && p.long).map(p => ({
                //         lat: Number(p.lat),
                //         lng: Number(p.long)
                //     }));
                //     console.log('Points:', points);

                //     if (points.length) {
                //         this.initMapWithPoints(points);
                //     } else {
                //         console.warn("No valid points to show on the map");
                //     }
                // }
                if (res.success && Array.isArray(res.data)) {
                    const customer_location = {
                        lat: +this.data.lat,
                        lng: +this.data.lng
                    };
                    this.initMapWithPoints(res.data, customer_location);



                }

            });

        }
        if(this.type =='ViewProspectTimeline'){
            this.salesService.getProspectTimeline(this.data.id).subscribe(
                (res: any) => {
                    this.timelinedata = res.data;

                },
            );
            }

        if(this.type== 'showBarcodes'){
            this.taskService.getBarcodes(this.data).subscribe((data) => {
                this.barcodeList=data.data;
               });

        }

        if(this.type== 'rolepermission'){
            this.roleService.permissionList(this.data.id).subscribe((data) => {
                // Old code
                const hashMap = [];
                data.respnseArray.map(perm =>{
                    const i = perm.name.lastIndexOf('-');
                    const key = perm.name.slice(0,i)
                    const value = perm.name.slice(i+1)+'-'+perm.id+'-'+perm.flag;
                    if(perm.flag == 'true'){
                        this.permissionForRole.push(perm.id.toString());
                    }
                    if(key in hashMap) {
                        hashMap[key].push(value)
                    } else {
                        hashMap[key] = [value]
                    }
                });
                const filterData = Object.keys(hashMap);
                for (let index = 0; index < filterData.length; index++) {
                    const h = filterData[index]+','+hashMap[filterData[index]];
                    this.permissionList[index]=h.split(',');
                }

                // New 25/04/2025
                // let hashMap: { [key: string]: string[] } = {};
                // data.respnseArray.map(perm => {
                //     const i = perm.name.lastIndexOf('-');
                //     const key = perm.name.slice(0, i);
                //     const value = perm.name.slice(i + 1) + '-' + perm.id + '-' + perm.flag;

                //     if (perm.flag === 'true') {
                //         this.permissionForRole.push(perm.id.toString());
                //     }

                //     if (hashMap[key]) {
                //         hashMap[key].push(value);
                //     } else {
                //         hashMap[key] = [value];
                //     }
                // });
                // this.permissionList = Object.keys(hashMap).map(key => ({
                //     group: key,
                //     permissions: hashMap[key]
                // }));

                // console.log(this.permissionList);

               });
                        this.isLoadedTable = false;
        }



        if(this.type == 'viewReportDetails'){
            this.isLoadedTable = true;
            // Default
            const short = `&sd=${this.sortDirection}`;
            const filtersortColumn = `&sb=${this.sortColumn}`;
            // If Has any
            const searchbox = this.searchNamefilter ? `&s=${this.searchNamefilter}` : '';
            this.orderService.getreportlist(this.data.order_id).subscribe((data) => {
                this.orderReportList = data.data;
                this.isLoadedTable = false;
            });

        }
        if(this.type == 'ViewOrderDoc'){
            this.isLoadedTable = true;
            this.orderService.barcodesAndDocument(this.data.id).subscribe(
                (res: any) => {
                    //
                    this.barcodedata = res.data;


                    this.barcodedoc = res.test_document;
                        const array = [];
                    if(this.barcodedata.length > 0){
                        for (let index = 0; index < this.barcodedata.length; index++) {
                            // this.barcodedata[index].updated_at  = '-';
                        //    if(this.barcodedata[index].packet_barcode){
                        //     this.orderService.getRunnerbyBarcode(this.barcodedata[index].packet_barcode).subscribe(
                        //         (res: any) => {

                        //             if(res.data?.task_items[0]?.runner?.first_name){
                        //                 this.barcodedata[index].runner_name = res.data?.task_items[0]?.runner?.first_name+' '+res.data?.task_items[0]?.runner?.last_name;
                        //                 this.barcodedata[index].status = res.data?.task_items[0]?.status;
                        //                 // this.barcodedata[index].lab_location = res.data.drop_location_name;
                        //                 this.barcodeRunenr.push(this.barcodedata[index]);
                        //                 if(this.barcodedata.length-1 == index ){
                        //                   this.isLoadedTable = false;
                        //                }
                        //             }else{
                        //                 this.barcodeRunenr.push(this.barcodedata[index]);
                        //                 this.barcodedata[index].runner_name = '-';
                        //                 this.barcodedata[index].status = '-';
                        //                 // this.barcodedata[index].lab_location = '-';
                        //                 if(this.barcodedata.length-1 == index ){
                        //                   this.isLoadedTable = false;
                        //                }
                        //             }

                        //         });
                        //    }else{
                        //     this.barcodeRunenr.push(this.barcodedata[index]);
                        //     if(this.barcodedata.length-1 == index ){
                        //       this.isLoadedTable = false;
                        //    }
                        //    }
                        this.barcodeRunenr.push(this.barcodedata[index]);
                            if(this.barcodedata.length-1 == index ){
                              this.isLoadedTable = false;
                           }

                        }
                    }else{
                        this.barcodeRunenr = this.barcodedata ;
                        this.isLoadedTable = false;

                    }
                }
            );
            }


            if(this.type == 'assignLabLocation' || this.type == 'assignMultipleLabLocation'){
                // console.log(this.data); return;

                if (this.props.type === 'assignMultipleLabLocation') {
                    this.selectedVisitIds = this.props.selectedVisitIds;
                    this.fetchTestDetailsForSelectedVisits();
                }
                let searchQuery = '';
                if (this.userFacility) {
                    searchQuery = `facility_id=${this.userFacility}`;
                }
                // this.lablocationService.obtainLablocations(searchQuery).subscribe((data) => {
                //     this.lablocationList = data.data.rows;
                //     var thisData = [];
                //     data.data.rows.forEach((item) => {

                //         thisData.push({ value: item.id, text: item.location_name + " - " + item.address + " - " + "(" + item.location_code + ") " });

                //     });
                //     // this.selectorMultiple.add(thisData);
                //     this.location_addresslistForDropdown = thisData
                // });
                const labId = this.data?.assign_lab_id;

                const labLocationId = this.data?.visit_lab_location?.lab_location_id;
                // console.log('labLocationId:', labLocationId);

                let city_id: string | undefined;
                if (this.data?.address?.city_id) {
                    city_id = this.data.address.city_id;
                }

                this.settingService.getAllMainLabs(city_id).subscribe((data) => {
                    this.mainLabListForDropdown = data.data;
                    if (labId) {
                        const defaultLab = this.mainLabListForDropdown.find(item => item.id == labId);
                        if (defaultLab) {
                            this.selectedMainLab = defaultLab; // bind to [(ngModel)] in template if needed
                            this.onMainLabChange(defaultLab.id); // Load locations
                        }
                    }
                    // this.mainLabListForDropdown = data.data.map(item => ({
                    //     id: item.id,
                    //     name: item.lab_name
                    // }));
                });
                this.defaultLabLocationId = labLocationId;

                if(this.type == 'assignLabLocation'){
                this.orderService.getTestforLabLocation(this.data.id).subscribe(
                    (res: any) => {
                        this.visitTestsdata = res.data;
                        for (let index = 0; index < this.visitTestsdata.length; index++) {
                            this.addlablocation.push({id:this.visitTestsdata[index].id,visit_id: this.visitTestsdata[index].patient.visit_id,patient_id:this.visitTestsdata[index].visit_patient_id,visit_test_id:this.visitTestsdata[index].id,lab_location_id:this.visitTestsdata[index].visit_lab?.lab_location_id??null,lab_location_name:this.visitTestsdata[index].visit_lab?.lab_location_name??null,lab_location_city_id:this.visitTestsdata[index].visit_lab?.city_id??null});
                                //
                        }
                    }
                );}
            }


            if(this.type == 'pullreport'){
                const data = this.datepipe.transform(this.data.slot_date, 'dd-MM-YYYY');
                this.orderService.pullreportdata(this.data.patient_phone,data).subscribe(
                        (res: any) => {
                            this.pullreportdata = res.data;
                            this.patientDropdown = this.pullreportdata.data;
                        this.isLoadedTable = false;

                        }
                    );

                    }

                    if(this.type == 'runnerAssignByTour' || this.type == 'assignTask'){
                        this.runnerService.getRunnerBycity_id(this.clientId,0).subscribe((data) => {
                          this.runnerlistForDropdown = data.data;

                       } );
                       this.AssignRunnerForm = this.formBuilder.group({
                        runner_id: ['', Validators.required],
                        from_date: ['',Validators.required],
                        to_date: ['',Validators.required],
                    });

                       this.TourService.obtainTour(this.data.id).subscribe((data) => {

                      //  this.addTourForm.get('serving_city').setValue(data.data.serving_city);
                      this.assignRunnerData = data.data;
                      if (this.assignRunnerData.from_date) {
                        this.assignRunnerData.from_date = this.datepipe.transform(this.assignRunnerData.from_date, 'd-MM-YYYY')
                    } else {
                      this.assignRunnerData.from_date = ''
                    }
                      if (this.assignRunnerData.to_date) {
                        this.assignRunnerData.to_date = this.datepipe.transform(this.assignRunnerData.to_date, 'd-MM-YYYY')
                    } else {
                        this.assignRunnerData.to_date = ''
                    }


                    this.AssignRunnerForm.patchValue(this.assignRunnerData)

                    });


                    }


        if(this.type == 'cancelOrder'){
            this.orderService.getallcancellationreason().subscribe((data) => {
                this.canclereasonDropDown = data.data.all_reason;
            });
        }
        if(this.type == 'rescheduleOrder'){
            this.orderService.getallreschedulereason().subscribe((data) => {
                this.reschedulereasonDropDown = data.data.all_reason;
            });
        }




       this.assignForm = this.formBuilder.group({
        client_id:['1'],
        runner_id:[' ',Validators.required],
        tour_id:[''],
        task_id:['']

    });



        this.changeLocationForm = this.formBuilder.group({
            start_point:['',Validators.required],
            start_lat:['',Validators.required],
            start_long:['',Validators.required],
            end_point:['',Validators.required],
            end_lat:['',Validators.required],
            end_long:['',Validators.required],
        })

        this.editPhleboPlanForm = this.formBuilder.group({
            starting_point:['',Validators.required],
            start_lat:['',Validators.required],
            start_long:['',Validators.required],
            end_point:['',Validators.required],
            end_lat:['',Validators.required],
            end_long:['',Validators.required],
            start_time:['',Validators.required],
            end_time:['',Validators.required],
            plan_id:['',Validators.required],
            phlebo_id:['',Validators.required],

        })

        this.editVisitPlanForm = this.formBuilder.group({
            patient_address:['',Validators.required],
            lat:['',Validators.required],
            lng:['',Validators.required],
        })

        if(this.type == 'changelocation'){

            this.changeLocationForm.patchValue(this.data);
        }

        if(this.type == 'viewSalesRepAppointment'){
            this.salesService.getAppointmentbyIddata(this.data).subscribe((data) => {
                this.appointmentByIdData = data.data;
                this.isLoadedTable = false;
            });
        }
        if(this.type == 'editPhleboPlan'){
            this.editPhleboPlanForm.patchValue(this.data.phlebo);
            this.editPhleboPlanForm.patchValue(this.data);
        }

        if(this.type == 'editVisitPlan'){
            this.editVisitPlanForm.patchValue(this.data);
        }

        this.declineForm = this.formBuilder.group({
            comment: [''],
            visit_id: [''],
        });
        this.cashDepositTo = this.formBuilder.group({
            deposittype: ['',Validators.required],

        });


        this.cancellForm = this.formBuilder.group({
            reason_id:  ['',Validators.required],
            order_id: [''],
        });

        this.rescheduleForm = this.formBuilder.group({
            reason_id:  ['',Validators.required],
            order_id: [''],
            date: ['',Validators.required],
            slot: ['',Validators.required],
            address:[''],
            user_type: ['admin'],
            reschedule_note: [],

        });
        // if(this.type === 'confirmOrder'){
            this.confirmForm = this.formBuilder.group({
                visit_id: [''],
                date: ['',Validators.required],
                slot: ['',Validators.required],
                user_type: ['admin']

            });
        // }
        if (this.type === 'changeLocationOrder') {
            this.locationForm = this.formBuilder.group({
                visit_id: [''],
                latitude: ['',
                    [
                    Validators.required,
                    Validators.pattern(/^(\+|-)?(?:90(?:\.0+)?|[0-8]?\d(?:\.\d+)?)$/) // -90 to +90
                    ]
                ],
                longitude: [
                    '',
                    [
                    Validators.required,
                    Validators.pattern(/^(\+|-)?(?:180(?:\.0+)?|((1[0-7]\d)|([0-9]?\d))(?:\.\d+)?)$/) // -180 to +180
                    ]
                ]
            });
            if (this.data && this.data.lat && this.data.lng) {
                this.locationForm.patchValue({
                    visit_id: this.data.id,
                    latitude: this.data.lat,
                    longitude: this.data.lng
                });
            }
        }

       this.collectionForm = this.formBuilder.group({
            collection_type:  ['home',Validators.required],
            facility:  [""],

            
        });
        // console.log(this.data);
        this.locationPatientForm = this.formBuilder.group({
            location:  ['',Validators.required],
            patient_id:  [this.data,Validators.required],

            
        });

        

        

        this.roleForm = this.formBuilder.group({
            permission:  ['',Validators.required],
        });

        this.reconsileForm = this.formBuilder.group({
            reconcile_comment:  ['',Validators.required],
            reconcile_amount:  [''],
            visitId: [''],
        });

        this.Form = this.formBuilder.group({
            id: [''],
            discount : ['']
        });

        if(this.data?.reconcile_comment=='Full amount collected')
        {
            this.inputtype='0';
            this.reconsileForm.get('reconcile_comment').setValue(this.data.reconcile_comment);

        }else if(this.data?.reconcile_comment=='Partially collected (test/patient cancelled)')
        {
            this.inputtype='1';
            this.reconsileForm.get('reconcile_comment').setValue(this.data.reconcile_comment);

        }else if(this.data?.reconcile_comment=='Paid online/Static QR')
        {
            this.inputtype='1';
            this.reconsileForm.get('reconcile_comment').setValue(this.data.reconcile_comment);

        }else if(this.data?.reconcile_comment=='Partially collected (other reasons)')
        {
            this.inputtype='1';
            this.reconsileForm.get('reconcile_comment').setValue(this.data.reconcile_comment);

        }else if(this.data?.reconcile_comment=='Paid directly to client')
        {
            this.inputtype='0';
            this.reconsileForm.get('reconcile_comment').setValue(this.data.reconcile_comment);

        }else{
            this.inputtype='0';
            this.reconsileForm.get('reconcile_comment').setValue('');


        }

        this.reconsileForm.get('reconcile_amount').setValue(this.data?.reconcile_amount);

        this.rosterForm = this.formBuilder.group({
          customer_id:['1'],
          phlebo_id:[''],
          check_mon: [''],
          start_mon:[''],
          end_mon:[''],
          check_tue: [''],
          start_tue:[''],
          end_tue:[''],
          check_wed: [''],
          start_wed:[''],
          end_wed:[''],
          check_thu: [''],
          start_thu:[''],
          end_thu:[''],
          check_fri: [''],
          start_fri:[''],
          end_fri:[''],
          check_sat: [''],
          start_sat:[''],
          end_sat:[''],
          check_sun: [''],
          start_sun:[''],
          end_sun:[''],

      });
      if(this.data.rosters)
      {
      if(this.data.rosters.length>0)
      {
          for (let index = 0; index <this.data.rosters.length; index++) {


          if(this.data.rosters[index].day=='Mon')
          {
          this.rosterForm.get('check_mon').setValue(true);
          this.rosterForm.get('start_mon').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_mon').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Tue')
          {
          this.rosterForm.get('check_tue').setValue(true);
          this.rosterForm.get('start_tue').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_tue').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Wed')
          {
          this.rosterForm.get('check_wed').setValue(true);
          this.rosterForm.get('start_wed').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_wed').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Thu')
          {
          this.rosterForm.get('check_thu').setValue(true);
          this.rosterForm.get('start_thu').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_thu').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Fri')
          {
          this.rosterForm.get('check_fri').setValue(true);
          this.rosterForm.get('start_fri').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_fri').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Sat')
          {
          this.rosterForm.get('check_sat').setValue(true);
          this.rosterForm.get('start_sat').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_sat').setValue(this.data.rosters[index].end_time);
          }
          if(this.data.rosters[index].day=='Sun')
          {
          this.rosterForm.get('check_sun').setValue(true);
          this.rosterForm.get('start_sun').setValue(this.data.rosters[index].start_time);
          this.rosterForm.get('end_sun').setValue(this.data.rosters[index].end_time);
          }
      }
      }
  }

// -------------------runner------------------------


  this.rosterFormRunner = this.formBuilder.group({
    client_id:['1'],
    runner_id:[''],
    check_mon: [''],
    start_mon:[''],
    end_mon:[''],
    check_tue: [''],
    start_tue:[''],
    end_tue:[''],
    check_wed: [''],
    start_wed:[''],
    end_wed:[''],
    check_thu: [''],
    start_thu:[''],
    end_thu:[''],
    check_fri: [''],
    start_fri:[''],
    end_fri:[''],
    check_sat: [''],
    start_sat:[''],
    end_sat:[''],
    check_sun: [''],
    start_sun:[''],
    end_sun:[''],

});
if(this.data.rosters)
{
if(this.data.rosters.length>0)
{
    for (let index = 0; index<this.data.rosters.length; index++) {


    if(this.data.rosters[index].day=='mon')
    {
    this.rosterFormRunner.get('check_mon').setValue(true);
    this.rosterFormRunner.get('start_mon').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_mon').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='tue')
    {
    this.rosterFormRunner.get('check_tue').setValue(true);
    this.rosterFormRunner.get('start_tue').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_tue').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='wed')
    {
    this.rosterFormRunner.get('check_wed').setValue(true);
    this.rosterFormRunner.get('start_wed').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_wed').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='thu')
    {
    this.rosterFormRunner.get('check_thu').setValue(true);
    this.rosterFormRunner.get('start_thu').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_thu').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='fri')
    {
    this.rosterFormRunner.get('check_fri').setValue(true);
    this.rosterFormRunner.get('start_fri').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_fri').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='sat')
    {
    this.rosterFormRunner.get('check_sat').setValue(true);
    this.rosterFormRunner.get('start_sat').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_sat').setValue(this.data.rosters[index].end_time);
    }
    if(this.data.rosters[index].day=='sun')
    {
    this.rosterFormRunner.get('check_sun').setValue(true);
    this.rosterFormRunner.get('start_sun').setValue(this.data.rosters[index].start_time);
    this.rosterFormRunner.get('end_sun').setValue(this.data.rosters[index].end_time);
    }
}
}
}






    }
// initMapWithPoints(apiData: any[]) {
//   const mapElement = document.getElementById('mapPath');
//   if (!mapElement) {
//     console.error('Map container not found');
//     return;
//   }

//   // Convert all valid lat/long to numbers
//   const points = apiData.map(p => ({
//     lat: Number(p.lat),
//     lng: Number(p.long)
//   }));

//   if (!points.length) {
//     console.warn('No coordinates to show');
//     return;
//   }

//   const map = new google.maps.Map(mapElement, {
//     zoom: 14,
//     center: points[0]
//   });

//   // Place markers for all points
//   points.forEach((point, index) => {
//     let iconUrl;

//     if (index === 0 && points.length > 1) {
//       iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'; // Start
//     } else if (index === points.length - 1 && points.length > 1) {
//       iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'; // End
//     } else {
//       iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'; // Single or middle
//     }

//     new google.maps.Marker({
//       position: point,
//       map: map,
//       title: `Point ${index + 1}`,
//       icon: iconUrl
//     });
//   });

//   // Draw path only if there are 2 or more points
//   if (points.length > 1) {
//     new google.maps.Polyline({
//       path: points,
//       geodesic: true,
//       strokeColor: '#FF0000',
//       strokeOpacity: 0.8,
//       strokeWeight: 3,
//       map: map
//     });
//   }
// }
// old code
// initMapWithPoints(apiData: any[]) {
//   const mapElement = document.getElementById('mapPath');
//   if (!mapElement) {
//     console.error('Map container not found');
//     return;
//   }

//   // Remove consecutive duplicate coordinates, keep last occurrence
//   const uniquePoints: { lat: number, lng: number, address?: string, flag?: string }[] = [];
//   for (let i = 0; i < apiData.length; i++) {
//     const point = apiData[i];
//     const lat = Number(point.lat);
//     const lng = Number(point.long);

//     // Check if next point is duplicate
//     if (i < apiData.length - 1) {
//       const nextLat = Number(apiData[i + 1].lat);
//       const nextLng = Number(apiData[i + 1].long);
//       if (lat === nextLat && lng === nextLng) continue; // skip current, last one will be used
//     }

//     uniquePoints.push({ lat, lng, address: point.address, flag: point.flag });
//   }

//   if (!uniquePoints.length) {
//     console.warn('No coordinates to show');
//     return;
//   }

//   const map = new google.maps.Map(mapElement, {
//     zoom: 14,
//     center: uniquePoints[0]
//   });

//   // Map flag to custom title

//   uniquePoints.forEach((point, index) => {
//     let iconUrl;
//     let titleText = '';
//     switch (point.flag) {
//       case 'started':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
//          titleText = 'Departed for Task Location';
//         break;
//       case 'reached':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
//         titleText = 'Arrived at Task Location';
//         break;
//       case 'Enroute To Lab':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
//         titleText = 'Departed for Lab Location';
//         break;
//       case 'Dropped In Lab':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png';
//          titleText = 'Arrived at Lab Location';
//         break;
//       default:
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';
//     }

//     const marker = new google.maps.Marker({
//       position: { lat: point.lat, lng: point.lng },
//       map: map,
//       icon: iconUrl
//     });

//     // Show address or custom title on hover

//     const contentString = `
//     <div style="
//         min-width:220px;
//         font-family: Arial, sans-serif;
//         line-height:1.5;
//         padding: 2px 12px 8px 12px; /* top padding smaller */
//         border-radius: 8px;
//         box-shadow: 0 2px 6px rgba(0,0,0,0.2);
//         background-color: #fff;
//     ">
//         <h3 style="
//         margin:0 0 4px 0; /* smaller margin */
//         font-size:16px;
//         color:#2c3e50;
//         font-weight:600;
//         ">
//         ${titleText}
//         </h3>
//         <p style="
//         margin:0;
//         font-size:14px;
//         color:#34495e;
//         ">
//         ${point.address || ''}
//         </p>
//     </div>
//     `;

//     const infoWindow = new google.maps.InfoWindow({
//         content: contentString,
//         disableAutoPan: true,
//         pixelOffset: new google.maps.Size(0, -30)
//     });

//     marker.addListener('mouseover', () => infoWindow.open(map, marker));
//     marker.addListener('mouseout', () => infoWindow.close());
//   });

//   // Draw polyline for all points
//   if (uniquePoints.length > 1) {
//     new google.maps.Polyline({
//       path: uniquePoints.map(p => ({ lat: p.lat, lng: p.lng })),
//       geodesic: true,
//       strokeColor: '#FF0000',
//       strokeOpacity: 0.8,
//       strokeWeight: 3,
//       map: map
//     });
//   }
// }

// 17th aug code
// initMapWithPoints(apiData: any[], customer_location?: { lat: number, lng: number }) {
//   const mapElement = document.getElementById('mapPath');
//   if (!mapElement) {
//     console.error('Map container not found');
//     return;
//   }

//   // Remove consecutive duplicate coordinates, keep last occurrence
//   const uniquePoints: { lat: number, lng: number, address?: string, flag?: string }[] = [];
//   for (let i = 0; i < apiData.length; i++) {
//     const point = apiData[i];
//     const lat = Number(point.lat);
//     const lng = Number(point.long);

//     if (i < apiData.length - 1) {
//       const nextLat = Number(apiData[i + 1].lat);
//       const nextLng = Number(apiData[i + 1].long);
//       if (lat === nextLat && lng === nextLng) continue;
//     }

//     uniquePoints.push({ lat, lng, address: point.address, flag: point.flag });
//   }

//   if (!uniquePoints.length) {
//     console.warn('No coordinates to show');
//     return;
//   }

//   const map = new google.maps.Map(mapElement, {
//     zoom: 14,
//     center: uniquePoints[0]
//   });

//   // ✅ Directions services
//   const directionsService = new google.maps.DirectionsService();
//   const directionsRenderer = new google.maps.DirectionsRenderer({
//     suppressMarkers: true, // we'll add our own markers
//     polylineOptions: {
//       strokeColor: '#FF0000',
//       strokeOpacity: 0.8,
//       strokeWeight: 4
//     }
//   });
//   directionsRenderer.setMap(map);
//   if (customer_location?.lat && customer_location?.lng) {
//     const homeMarker = new google.maps.Marker({
//       position: { lat: customer_location.lat, lng: customer_location.lng },
//       map,
//       icon: {
//         url: 'assets/icons/home.png',
//         scaledSize: new google.maps.Size(40, 40)
//       },
//       title: "Customer Home"
//     });
//   }
//   // Add markers
//   uniquePoints.forEach((point, index) => {
//     let iconUrl;
//     let titleText = '';
//     switch (point.flag) {
//       case 'started':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
//         titleText = 'Departed for Task Location';
//         break;
//       case 'reached':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
//         titleText = 'Arrived at Task Location';
//         break;
//       case 'Enroute To Lab':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
//         titleText = 'Departed for Lab Location';
//         break;
//       case 'Dropped In Lab':
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png';
//         titleText = 'Arrived at Lab Location';
//         break;
//       default:
//         iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';
//     }

//     const marker = new google.maps.Marker({
//       position: { lat: point.lat, lng: point.lng },
//       map,
//       icon: iconUrl
//     });

//     const contentString = `
//       <div style="
//         min-width:220px; font-family:Arial,sans-serif; line-height:1.5;
//         padding:2px 12px 8px 12px; border-radius:8px;
//         box-shadow:0 2px 6px rgba(0,0,0,0.2); background-color:#fff;">
//         <h3 style="margin:0 0 4px 0;font-size:16px;color:#2c3e50;font-weight:600;">
//           ${titleText}
//         </h3>
//       </div>`;

//     const infoWindow = new google.maps.InfoWindow({
//       content: contentString,
//       disableAutoPan: true,
//       pixelOffset: new google.maps.Size(0, -30)
//     });

//     marker.addListener('mouseover', () => infoWindow.open(map, marker));
//     marker.addListener('mouseout', () => infoWindow.close());
//   });

//   // ✅ Build route (multi-stop)
//   if (uniquePoints.length > 1) {
//     const origin = uniquePoints[0];
//     const destination = uniquePoints[uniquePoints.length - 1];
//     const waypoints = uniquePoints.slice(1, -1).map(p => ({
//       location: { lat: p.lat, lng: p.lng },
//       stopover: true
//     }));

//     directionsService.route(
//       {
//         origin,
//         destination,
//         waypoints,
//         travelMode: google.maps.TravelMode.DRIVING
//       },
//       (result, status) => {
//         if (status === google.maps.DirectionsStatus.OK) {
//           directionsRenderer.setDirections(result);
//         } else {
//           console.error('Directions request failed:', status);
//         }
//       }
//     );
//   }
// }

// 18 aug code
// initMapWithPoints(apiData: any[], customer_location?: { lat: number, lng: number }) {
//   const mapElement = document.getElementById('mapPath');
//   if (!mapElement) {
//     console.error('Map container not found');
//     return;
//   }

//   // ✅ Keep all points (no deduplication)
//   const points: { lat: number, lng: number, address?: string, flag?: string }[] = apiData.map(p => ({
//     lat: Number(p.lat),
//     lng: Number(p.long),
//     address: p.address,
//     flag: p.flag
//   }));

//   if (!points.length) {
//     console.warn('No coordinates to show');
//     return;
//   }

//   const map = new google.maps.Map(mapElement, {
//     zoom: 14,
//     center: points[0]
//   });

//   const directionsService = new google.maps.DirectionsService();
//   const directionsRenderer = new google.maps.DirectionsRenderer({
//     suppressMarkers: true,
//     polylineOptions: {
//       strokeColor: '#FF0000',
//       strokeOpacity: 0.8,
//       strokeWeight: 4
//     }
//   });
//   directionsRenderer.setMap(map);

//   // ✅ Add Home marker separately
//   if (customer_location?.lat && customer_location?.lng) {
//     new google.maps.Marker({
//       position: { lat: customer_location.lat, lng: customer_location.lng },
//       map,
//       icon: {
//         url: 'assets/icons/home.png',
//         scaledSize: new google.maps.Size(40, 40)
//       },
//       title: "Customer Home"
//     });
//   }

//   // ✅ Add markers
//   points.forEach((point, index) => {
//     let iconUrl;
//     let titleText = '';

//     // Check for "reached" + "Enroute To Lab" at the same lat/lng
//     const nextPoint = points[index + 1];
//     if (
//       point.flag === 'reached' &&
//       nextPoint &&
//       nextPoint.flag === 'Enroute To Lab' &&
//       point.lat === nextPoint.lat &&
//       point.lng === nextPoint.lng
//     ) {
//       iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'; // Enroute color or your choice
//       titleText = 'Arrived at Task Location and Departed for Lab Location';
//     } else {
//       switch (point.flag) {
//         case 'started':
//           iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
//           titleText = 'Departed for Task Location';
//           break;
//         case 'reached':
//           iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
//           titleText = 'Arrived at Task Location';
//           break;
//         case 'Enroute To Lab':
//           iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
//           titleText = 'Departed for Lab Location';
//           break;
//         case 'Dropped In Lab':
//           iconUrl = 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png';
//           titleText = 'Arrived at Lab Location';
//           break;
//         default:
//           iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';
//       }
//     }

//     const marker = new google.maps.Marker({
//       position: { lat: point.lat, lng: point.lng },
//       map,
//       icon: iconUrl
//     });

//     const contentString = `
//       <div style="
//         min-width:220px; font-family:Arial,sans-serif; line-height:1.5;
//         padding:2px 12px 8px 12px; border-radius:8px;
//         box-shadow:0 2px 6px rgba(0,0,0,0.2); background-color:#fff;">
//         <h3 style="margin:0 0 4px 0;font-size:16px;color:#2c3e50;font-weight:600;">
//           ${titleText}
//         </h3>
//       </div>`;

//     const infoWindow = new google.maps.InfoWindow({
//       content: contentString,
//       disableAutoPan: true,
//       pixelOffset: new google.maps.Size(0, -30)
//     });

//     marker.addListener('mouseover', () => infoWindow.open(map, marker));
//     marker.addListener('mouseout', () => infoWindow.close());
//   });

//   // ✅ Build route (multi-stop)
//   if (points.length > 1) {
//     const origin = points[0];
//     const destination = points[points.length - 1];
//     const waypoints = points.slice(1, -1).map(p => ({
//       location: { lat: p.lat, lng: p.lng },
//       stopover: true
//     }));

//     directionsService.route(
//       { origin, destination, waypoints, travelMode: google.maps.TravelMode.DRIVING },
//       (result, status) => {
//         if (status === google.maps.DirectionsStatus.OK) {
//           directionsRenderer.setDirections(result);
//         } else {
//           console.error('Directions request failed:', status);
//         }
//       }
//     );
//   }
// }
initMapWithPoints(apiData: any[], customer_location?: { lat: number, lng: number }) {
  const mapElement = document.getElementById('mapPath');
  if (!mapElement) {
    console.error('Map container not found');
    return;
  }

  const points: { lat: number, lng: number, address?: string, flag?: string }[] = apiData.map(p => ({
    lat: Number(p.lat),
    lng: Number(p.long),
    address: p.address,
    flag: p.flag
  }));

  if (!points.length) {
    console.warn('No coordinates to show');
    return;
  }

  const map = new google.maps.Map(mapElement, {
    zoom: 14,
    center: points[0]
  });

  const directionsService = new google.maps.DirectionsService();
  const directionsRenderer = new google.maps.DirectionsRenderer({
    suppressMarkers: true,
    polylineOptions: { strokeColor: '#FF0000', strokeOpacity: 0.8, strokeWeight: 4 }
  });
  directionsRenderer.setMap(map);

  // Add customer/home marker
  if (customer_location?.lat && customer_location?.lng) {
    new google.maps.Marker({
      position: { lat: customer_location.lat, lng: customer_location.lng },
      map,
      icon: { url: 'assets/icons/home.png', scaledSize: new google.maps.Size(40, 40) },
      title: 'Task Location'
    });
  }

  // Add markers
  points.forEach((point, index) => {
    let iconUrl, titleText = '';

    const nextPoint = points[index + 1];
    if (point.flag === 'reached' && nextPoint && nextPoint.flag === 'Enroute To Lab' &&
        point.lat === nextPoint.lat && point.lng === nextPoint.lng) {
      iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
      titleText = 'Arrived at Task Location and Departed for Lab Location';
    } else {
      switch (point.flag) {
        case 'started': iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'; titleText = 'Departed for Task Location'; break;
        case 'reached': iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'; titleText = 'Arrived at Task Location'; break;
        case 'Enroute To Lab': iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'; titleText = 'Departed for Lab Location'; break;
        case 'Dropped In Lab': iconUrl = 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png'; titleText = 'Arrived at Lab Location'; break;
        default: iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';
      }
    }

    const marker = new google.maps.Marker({ position: { lat: point.lat, lng: point.lng }, map, icon: iconUrl });
    const contentString = `<div style="min-width:220px;font-family:Arial,sans-serif;line-height:1.5;
      padding:2px 12px 8px 12px;border-radius:8px;box-shadow:0 2px 6px rgba(0,0,0,0.2);background-color:#fff;">
      <h3 style="margin:0 0 4px 0;font-size:16px;color:#2c3e50;font-weight:600;">${titleText}</h3>
    </div>`;

    const infoWindow = new google.maps.InfoWindow({ content: contentString, disableAutoPan: true, pixelOffset: new google.maps.Size(0, -30) });
    marker.addListener('mouseover', () => infoWindow.open(map, marker));
    marker.addListener('mouseout', () => infoWindow.close());
  });

  // Fit bounds
  const bounds = new google.maps.LatLngBounds();
  points.forEach(p => bounds.extend({ lat: p.lat, lng: p.lng }));
  if (customer_location) bounds.extend({ lat: customer_location.lat, lng: customer_location.lng });
  map.fitBounds(bounds);

  // Build route with tiny offset for duplicates
  if (points.length > 1) {
    const origin = points[0];
    const destination = points[points.length - 1];
    const waypoints = points.slice(1, -1).map((p, i) => ({
      location: {
        lat: p.lat + i * 0.000001, // tiny offset
        lng: p.lng + i * 0.000001
      },
      stopover: true
    }));

    directionsService.route(
      { origin, destination, waypoints, travelMode: google.maps.TravelMode.DRIVING },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) directionsRenderer.setDirections(result);
        else console.error('Directions request failed:', status);
      }
    );
  }
}















    fetchTestDetailsForSelectedVisits() {
        this.selectedVisitIds.forEach(visitId => {
            this.orderService.getTestforLabLocation(visitId).subscribe(
                (res: any) => {
                    if (res && res.success) {
                        this.visitTestsdata = this.visitTestsdata.concat(res.data);
                        // console.log('visit detail', this.visitTestsdata);

                        this.prepareLabLocationData(res.data); // Prepare lab location data for each test
                    } else {
                        this.toastr.error('Failed to fetch test details for visit ID: ' + visitId);
                    }
                },
                (err: any) => {
                    this.toastr.error('Error fetching test details for visit ID: ' + visitId);
                }
            );
        });
    }

    prepareLabLocationData(testData: any[]) {
        testData.forEach(test => {
            this.addlablocation.push({
                id: test.id,
                visit_id: test.patient.visit_id,
                patient_id: test.visit_patient_id,
                visit_test_id: test.id,
                lab_location_id: test.visit_lab?.lab_location_id ?? null,
                lab_location_name: test.visit_lab?.lab_location_name ?? null,
                lab_location_city_id: test.visit_lab?.city_id ?? null
            });
        });
    }

    // insertLab(event: any, testId: number) {
    //     const selectedLabLocation = event;
    //     const testIndex = this.addlablocation.findIndex(item => item.visit_test_id === testId);
    //     if (testIndex !== -1) {
    //         this.addlablocation[testIndex].lab_location_id = selectedLabLocation.id;
    //         this.addlablocation[testIndex].lab_location_name = selectedLabLocation.name;
    //     }
    // }

    databypatientid(event){
        this.patientReportData2.patient_id = event.target.value;
        this.patientReportData2.order_id =this.data.order_id;
        //

    }

    addReportData(data,url){
        this.itdosReportData =
        {
            data:[
                {
                    test_report:url,
                    order_id:'',
                    patient_id:'',
                    enduser_id:'81'
                }
            ]
        };

        this.patientReportData = {test:[]};
        for (let index = 0; index < data.length; index++) {
            this.patientReportData.test[index]= {test_name:data[index].Investigation_name,observation:[]};
            for (let item = 0; item < data[index].ObservationDetails.length; item++) {
            this.patientReportData.test[index].observation[item]=
                {observation_name:data[index].ObservationDetails[item].name,
                value:data[index].ObservationDetails[item].value,
                unit:data[index].ObservationDetails[item].Unit,
                start_range:data[index].ObservationDetails[item].MinValue,
                end_range:data[index].ObservationDetails[item].MaxValue};
        }
        }
    }
    get runnerAssignInfo() {
        return this.AssignRunnerForm.controls;
    }


    addPatientReport() {
        this.nextSaveBtnLoding = true;
        this.patientReportData.patient_id = this.patientReportData2.patient_id;
        this.patientReportData.order_id = this.patientReportData2.order_id;

        this.itdosReportData.data[0].order_id = this.data.order_id;
        this.itdosReportData.data[0].patient_id =  this.patientReportData2.patient_id;
        this.itdosReportData.data[0].enduser_id = this.data.client_id;
            this.enduserService.addPatientReport(this.patientReportData).subscribe(
                (res: any) => {
                    if (res.success) {

                        this.orderService.additdosReport(this.itdosReportData).subscribe(
                            (res: any) => {
                                if (res.success) {
                                    this.toastr.success(res.message);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                        this.nextSaveBtnLoding = false;

                                    } else {
                                        this.toastr.error(`Report attached to patient`);
                                    }
                                }
                            },
                            (err: any) => {
                                this.toastr.error(`${err}`);
                            },
                            () => {
                                this.nextSaveBtnLoding = false;
                            }
                        );

                        // this.toastr.success(res.msg);
                        // this.onClose();
                    } else {
                        if (res.msg) {
                            this.toastr.error(`${res.msg}`);
                            this.nextSaveBtnLoding = false;

                        } else {
                            this.toastr.error(`Report attached to patient`);
                        }
                    }
                },
                (err: any) => {
                    this.toastr.error(`${err}`);
                },
                () => {
                    // this.nextSaveBtnLoding = false;
                    // this.EnduserTouchSubmit = false;
                }
            );
        // }
    }

    deleteReport(id){
        this.isLoadedTable = true;
        this.isBtnLoaded = true;
        this.orderService.deletereport(id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.toastr.success(res.message);
                    this.orderService.getreportlist(this.data.order_id).subscribe((data) => {
                        this.orderReportList = data.data;
                        this.isLoadedTable = false;
                    });
                    // this.onClose();
                    // this.router.navigate(['customers']);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(res.error);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                // this.nextSaveBtnLoding = false;
                // this.EnduserTouchSubmit = false;
                this.isBtnLoaded = false;
            }
        );
    }

    onChangeMarkavailable(event,id){
        if(this.markavailabledata.length){
        const update = false;


            for (let index = 0; index < this.markavailabledata.length; index++){
            if(this.markavailabledata[index].patient_id == id){
                const update = true;
                if(event.target.checked){
                this.markavailabledata[index].value = 1;
                }else{
                    this.markavailabledata[index].value = 0;
                }
            }
        };
        if(!update){
            if(event.target.checked){
                this.markavailabledata.push({patient_id: id,value:1})
            }else{
                this.markavailabledata.push({patient_id: id,value:0});
            }
        }


        }else{


            if(event.target.checked){
                this.markavailabledata.push({patient_id: id,value:1})
            }else{
                this.markavailabledata.push({patient_id: id,value:0});
            }
        }

    }

    onSaveAvailableReport(){
        this.isBtnLoaded = true;
        this.orderService.markavailablereport({order_id:this.data.order_id,report:this.markavailabledata}).subscribe(
            (res: any) => {
                if (res.success) {
                    this.toastr.success(res.message);
                    this.onClose();
                    // this.router.navigate(['customers']);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(res.error);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                // this.nextSaveBtnLoding = false;
                // this.EnduserTouchSubmit = false;
                this.isBtnLoaded = false;
            }
        );
    }






    getAllSlot() {
        if (this.data.patient_address_id != '') {

            if (this.rescheduleForm.value.date || this.confirmForm.value.date) {
                if (typeof (this.rescheduleForm?.value?.date) == 'object') {
                    this.rescheduleForm.patchValue({address:this.data.patient_address_id});

                    this.rescheduleForm.value.date = this.datepipe.transform(this.rescheduleForm.value.date, 'YYYY-MM-dd HH:MM:ss')

                }

                if (typeof (this.confirmForm?.value?.date) == 'object') {

                    this.confirmForm.value.date = this.datepipe.transform(this.confirmForm.value.date, 'YYYY-MM-dd HH:MM:ss')
                    // const formattedDate = this.datepipe.transform(this.confirmForm.value.date, 'dd-MM-yyyy');
                    // this.confirmForm.patchValue({ date: formattedDate });

                }
                // this.rescheduleForm.get('address').setValue(this.data.patient_address_id);

                this.slotlistForDropdown = [];
                const requestPayload = this.rescheduleForm?.value?.date ? this.rescheduleForm.value : this.confirmForm.value;
                this.orderService.getallSlot(requestPayload).subscribe((data) => {
                    if (data?.data?.time_slot) {
                        this.slotlistForDropdown = data.data?.time_slot;
                    }
                    if (data.message) {
                        // this.toastr.success(`${data.message}`);
                    } else {
                        if (data.error) {
                            this.toastr.error(data.error);
                        } else {
                            this.toastr.success(`Slot Found`);
                        }
                    }

                }, (err) => {
                    if (err.message) {
                        this.toastr.error(`${err.message}`);
                    } else {
                        this.toastr.error(`not Found`);
                    }
                });
            }

        } else {
            this.toastr.success(`Please Select Address first`);
        }
    }

    // getAllSlot() {
    //     if (this.data.patient_address_id != '') {

    //         const rescheduleDate = this.rescheduleForm?.value?.date;
    //         const confirmDate = this.confirmForm?.value?.date;

    //         if (rescheduleDate || confirmDate) {

    //         if (typeof rescheduleDate == 'object') {
    //             this.rescheduleForm.patchValue({ address: this.data.patient_address_id });
    //             this.rescheduleForm.patchValue({
    //             date: this.datepipe.transform(rescheduleDate, 'YYYY-MM-dd HH:mm:ss')
    //             });
    //         }

    //         if (typeof confirmDate == 'object') {
    //             this.confirmForm.patchValue({ address: this.data.patient_address_id });
    //             this.confirmForm.patchValue({
    //             date: this.datepipe.transform(confirmDate, 'YYYY-MM-dd HH:mm:ss')
    //             });
    //         }

    //         this.slotlistForDropdown = [];

    //         const requestPayload = rescheduleDate
    //             ? this.rescheduleForm.value
    //             : this.confirmForm.value;

    //         this.orderService.getallSlot(requestPayload).subscribe(
    //             (data) => {
    //             if (data?.data?.time_slot) {
    //                 this.slotlistForDropdown = data.data.time_slot;
    //             }else{
    //                 if (data.error) {
    //                     this.toastr.error(data.error);
    //                 } else {
    //                     this.toastr.success(`Slot Found`);
    //                 }
    //             }
    //             },
    //             (err) => {
    //             this.toastr.error(err?.message || 'not Found');
    //             }
    //         );
    //         }

    //     } else {
    //         this.toastr.error(`Please Select Address first`);
    //     }
    // }



//     getAllSlot() {
//     if (!this.data.patient_address_id) {
//         this.toastr.error(`Please Select Address first`);
//         return;
//     }

//     const rescheduleDate = this.rescheduleForm?.value?.date;
//     const confirmDate = this.confirmForm?.value?.date;
//     const selectedDate = rescheduleDate || confirmDate;

//     if (!selectedDate) return;

//   // ✅ If rescheduleForm date exists
//   if (rescheduleDate && typeof rescheduleDate == 'object') {
//     this.rescheduleForm.patchValue({
//       address: this.data.patient_address_id,
//       date: this.datepipe.transform(rescheduleDate, 'YYYY-MM-dd HH:mm:ss')
//     });
//   }

//   // ✅ If confirmForm date exists
//   if (confirmDate && typeof confirmDate == 'object') {
//     this.confirmForm.patchValue({
//       address: this.data.patient_address_id,
//       date: this.datepipe.transform(confirmDate, 'YYYY-MM-dd HH:mm:ss')
//     });
//   }

//   // ✅ Choose payload safely
//   const requestPayload = rescheduleDate ? this.rescheduleForm.value : this.confirmForm.value;

//   this.slotlistForDropdown = [];
//   this.orderService.getallSlot(requestPayload).subscribe((data) => {

//     if (data?.data?.time_slot) {
//         this.slotlistForDropdown = data.data.time_slot;
//     }else{
//         if (data.error) {
//             this.toastr.error(data.error);
//         } else {
//         this.toastr.error(`Slot Issue`);
//         }
//     }
        

    

//   }, (err) => {
//     this.toastr.error(err?.message || 'Not Found');
//   });
// }


    getAllTask(event)
    {
        this.taskService.getallTourbyrunner(event.target.value).subscribe((data) => {
            this.tourlistForDropdown = data.data;
        });


    }

    get declineInfo() {
        return this.declineForm.controls;
    }
    get depositInfo() {
        return this.cashDepositTo.controls;
    }
    get reasonInfo() {
        return this.cancellForm.controls;
    }
    get reasonrescheduleInfo() {
       return this.rescheduleForm.controls
    }
    get confirmInfo() {
       return this.confirmForm.controls
    }
    // easy getters
    get locationInfo() {
    return this.locationForm.controls;
    }
    get reconsileInfo() {
        return this.reconsileForm.controls;
    }
    get collectedInfo() {
        return this.markCollectedForm.controls;
    }
    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.subTitle = dialogdata.subTitle;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.page = dialogdata.page;
        // this.rescheduleForm.patchValue({"address":this.data.patient_address_id,"order_id":this.data.order_id});
        // this.rescheduleForm.patchValue({});
        //    this.assignForm.patchValue({"visit_id":this.data.id});
        // this.rosterForm.patchValue(this.data.rosters);
    }

    onClose() {
        this.passEntry.next(this.page);
        this.ngbModal.close();
    }
    onCloseNext() {
      //  this.router.navigateByUrl('orders');
       // this.router.navigate([currentUrl]);
        // window.location.reload();
        this.passEntry.next(this.page);
        this.ngbModal.close();
    }

    UserTypeCheck(mytype){
        this.inputtype='0';
        if(mytype=='Partially collected (test/patient cancelled)')
        {
            this.inputtype='1';
        }else if(mytype=='Paid online/Static QR')
        {
            this.inputtype='1';
        }else if(mytype=='Partially collected (other reasons)')
        {
            this.inputtype='1';
        }else if(mytype=='Partially collected (Reasons)'){
            this.inputtype='1';
        }else{
            this.inputtype='0';
        }
    }
        sendOrder() {
            this.onCloseNext();

          const collection_type = this.collectionForm.get('collection_type')?.value;
          const facility = this.collectionForm.get('facility')?.value;
                //   console.log(this.collectionForm)

            if(collection_type=="home")
            {
             this.router.navigateByUrl('orders/create');

            }else{
                this.router.navigateByUrl('orders/create/'+facility);

            }
        }


    onSaveReconsile() {
       
           switch (this.type) {
            case 'AddLocation':
                            // console.log(this.locationPatientForm)

                if (this.locationPatientForm.valid) {
                    this.isBtnLoaded = true;

                        this.orderService.addLocation(this.locationPatientForm.value).subscribe(
                            (res: any) => {
                                if (res && res.success) {

                                       this.toastr.success(`${res.message}`);
                                       this.onCloseNext();
                                   } else {
                                       if (res.message) {
                                           this.toastr.error(`${res.message}`);
                                       } else {
                                           this.toastr.error(`submit failed`);
                                       }
                                   }
                                   this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );


                } else {
                 this.locationPatientForm.markAllAsTouched();

                }
                break;

           

            case 'cashDepositTo':
                if (this.cashDepositTo.valid) {

                    // this.Form.get('id').setValue(this.data.id);

                    // this.showError = false;
                    this.isBtnLoaded = true;

                        this.orderService.cashDepositTo(this.cashDepositTo.value,this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.router.navigateByUrl('payment/phleboview');

                                       this.toastr.success(`${res.message}`);
                                       this.onCloseNext();
                                   } else {
                                       if (res.message) {
                                           this.toastr.error(`${res.message}`);
                                       } else {
                                           this.toastr.error(`submit failed`);
                                       }
                                   }
                                   this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );


                } else {
                 this.cashDepositTo.markAllAsTouched();

                }
                break;

            case 'ResetReconciliationVisit':


                    this.showError = false;
                    this.isBtnLoaded = true;

                        this.orderService.ResetReconcilePhleboStatus(this.data.id).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                 this.router.navigateByUrl('payment/phleboview');

                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`submit failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );



                break;
            case 'reconciliationVisit':


                if (this.reconsileForm.valid) {

                    this.reconsileForm.get('visitId').setValue(this.data.id);

                    this.showError = false;
                    this.isBtnLoaded = true;

                        this.orderService.reconcilePhleboStatus(this.reconsileForm.value).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                 this.router.navigateByUrl('payment/phleboview');

                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`submit failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );


                } else {
                 this.reconsileForm.markAllAsTouched();

                }
                break;


                case 'discount':


                    if (this.Form.valid) {

                        // this.Form.get('id').setValue(this.data.id);

                        // this.showError = false;
                        this.isBtnLoaded = true;

                            this.invoiceService.addDiscount(this.Form.value,this.data.id).subscribe(
                                (res: any) => {
                                    if (res && res.success) {

                                        this.toastr.success(`${res.message}`);
                                        this.onCloseNext();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`submit failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);
                                }
                            );


                    } else {
                     this.reconsileForm.markAllAsTouched();
                    }
                    break;


                case 'bulkReconciliationVisit':


                    if (this.reconsileForm.valid) {

                        this.showError = false;
                        this.isBtnLoaded = true;

                            this.orderService.reconcileBulkPhleboStatus(this.reconsileForm.value,this.data).subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                     this.router.navigateByUrl('payment/phleboview');

                                        this.toastr.success(`${res.message}`);
                                        this.onCloseNext();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`submit failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);
                                }
                            );


                    } else {
                     this.reconsileForm.markAllAsTouched();

                    }
                    break;
                case 'rescheduleOrder':
                    this.reasonrescheduletouched = true;

                   if (this.rescheduleForm.valid) {
                    this.rescheduleForm.get('order_id').setValue(this.data.order_id);
                    const rawDate = this.rescheduleForm.value.date;
                    const formattedDate = this.datepipe.transform(rawDate, 'yyyy-MM-dd');

                    const payload = {
                            ...this.rescheduleForm.value,
                            date: formattedDate
                    };

                    this.isBtnLoaded = true;
                    //    this.showError = false;

                           this.orderService.saveRescheduelReason(payload).subscribe(
                               (res: any) => {
                                   if (res && res.success) {
                                    // this.router.navigateByUrl('orders/edit/'+res.data.order_id+'/'+res.data.visit_id);

                                       this.toastr.success(`${res.message}`);
                                       this.onCloseNext();
                                   } else {
                                       if (res.error) {
                                            this.onClose();
                                           this.toastr.error(`${res.error}`);
                                       } else {
                                            this.onClose();
                                           this.toastr.error(`Reschedule failed`);
                                       }
                                   }
                                   this.isBtnLoaded = false;
                               },
                               (err: any) => {
                                   this.onClose();
                                   this.toastr.error(`${err.statusText}`);
                               }
                           );


                   } else {
                    this.rescheduleForm.markAllAsTouched();
                    this.reasonrescheduletouched = false;
                   }
                   this.reasonrescheduletouched = false;
                   break;

                case 'confirmOrder':
                    this.confirmtouched = true;

                    if (this.confirmForm.valid) {
                        
                        this.confirmForm.get('visit_id').setValue(this.data.id);
                        const rawDate = this.confirmForm.value.date;
                        const formattedDate = this.datepipe.transform(rawDate, 'yyyy-MM-dd');

                        const payload = {
                            ...this.confirmForm.value,
                            date: formattedDate
                        };

                        // console.log(payload); return;
                        // console.log(this.confirmForm.value); return;
                        
                        this.isBtnLoaded = true;
                        //    this.showError = false;

                        this.orderService.saveConfirmVisit(payload).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.error) {
                                        this.onClose();
                                       this.toastr.error(`${res.error}`);
                                    } else {
                                        this.onClose();
                                        this.toastr.error(`Confirm failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                           },
                                (err: any) => {
                                   this.onClose();
                                   this.toastr.error(`${err.statusText}`);
                                }
                            );
                    } else {
                        this.confirmForm.markAllAsTouched();
                        this.confirmtouched = false;
                    }
                    this.confirmtouched = false;
                   break;

                case 'changeLocationOrder':

                    this.locationTouched = true;

                    if (this.locationForm.valid) {
                        // Ensure visit_id is always set from modal data
                        this.locationForm.get('visit_id')?.setValue(this.data.id);
                        // console.log('changeLocationOrder');
                        // console.log(this.locationForm.value);

                        // return;
                        this.isBtnLoaded = true;

                        this.orderService.saveLocationLatLongChange(this.locationForm.value).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.error) {
                                        this.onClose();
                                        this.toastr.error(`${res.error}`);
                                    } else {
                                        this.onClose();
                                        this.toastr.error(`Location update failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                                this.isBtnLoaded = false;
                            }
                        );
                    } else {
                        this.locationTouched = true;
                        this.locationForm.markAllAsTouched();
                        return;
                        // this.locationTouched = false;
                    }

                    this.locationTouched = false;
                    break;


                   case 'cancelOrder':


                    if (this.cancellForm.valid) {

                        this.cancellForm.get('order_id').setValue(this.data.order_id);

                        this.showError = false;
                        this.isBtnLoaded = true;

                            this.orderService.saveCancellationReason(this.cancellForm.value).subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                        this.toastr.success(`${res.message}`);
                                        this.onCloseNext();
                                    } else {
                                        if (res.error) {
                                            this.onClose();
                                            this.toastr.error(`${res.error}`);
                                        } else {
                                            this.onClose();
                                            this.toastr.error(`Cancel failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    // console.log('error',err);

                                    this.toastr.error(`${err.statusText}`);
                                }
                            );


                    } else {
                        this.cancellForm.markAllAsTouched();

                    }
                    break;

           }
       }

       onSaveRoster() {

        switch (this.type) {
            case 'changelocation':
                this.phleboTouchSubmit=true;
                    if (this.changeLocationForm.valid) {
                        this.showError = false;
                        this.nextSaveBtnLoding = true;
                            this.phleboService.changeLocation(this.changeLocationForm.value,this.data.id).subscribe(

                                (res: any) => {
                                    if (res && res.success) {

                                        this.toastr.success(`${res.message.charAt(0).toUpperCase() + res.message.slice(1)}`);
                                        this.onCloseNext();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`submit failed`);
                                        }
                                    }
                                    this.nextSaveBtnLoding = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);

                                    this.phleboTouchSubmit=false;
                                }
                            );


                    } else {
                        this.showError = true;
                        this.rosterTouchSubmit=false;
                    }
                    break;
                    case 'editVisitPlan':
                      this.phleboTouchSubmit=true;
                          if (this.editVisitPlanForm.valid) {
                              this.showError = false;
                              this.nextSaveBtnLoding = true;
                              this.editVisitPlanForm.value.visit_id = this.data.id;
                                  this.planService.updateVisitPlan(this.editVisitPlanForm.value).subscribe(

                                      (res: any) => {
                                          if (res && res.status) {

                                              this.toastr.success(`${res.message.charAt(0).toUpperCase() + res.message.slice(1)}`);
                                              this.onCloseNext();
                                          } else {
                                              if (res.message) {
                                                  this.toastr.error(`${res.message}`);
                                              } else {
                                                  this.toastr.error(`submit failed`);
                                              }
                                          }
                                          this.nextSaveBtnLoding = false;
                                      },
                                      (err: any) => {
                                          this.onClose();
                                          this.toastr.error(`${err.statusText}`);

                                          this.phleboTouchSubmit=false;
                                      }
                                  );


                          } else {
                              this.showError = true;
                              this.rosterTouchSubmit=false;
                          }
                    break;



                    case 'editPhleboPlan':
                        this.phleboTouchSubmit=true;
                            if (this.editPhleboPlanForm.valid) {
                                this.showError = false;
                                this.nextSaveBtnLoding = true;
                                    this.planService.updatePhleboPlan(this.editPhleboPlanForm.value).subscribe(

                                        (res: any) => {
                                            if (res && res.status) {

                                                this.toastr.success(`${res.message.charAt(0).toUpperCase() + res.message.slice(1)}`);
                                                this.onCloseNext();
                                            } else {
                                                if (res.message) {
                                                    this.toastr.error(`${res.message}`);
                                                } else {
                                                    this.toastr.error(`submit failed`);
                                                }
                                            }
                                            this.nextSaveBtnLoding = false;
                                        },
                                        (err: any) => {
                                            this.onClose();
                                            this.toastr.error(`${err.statusText}`);

                                            this.phleboTouchSubmit=false;
                                        }
                                    );


                            } else {
                                this.showError = true;
                                this.rosterTouchSubmit=false;
                            }

                            break;

                            case 'editPhleboPlan':
                                this.phleboTouchSubmit=true;
                                    if (this.editPhleboPlanForm.valid) {
                                        this.showError = false;
                                        this.nextSaveBtnLoding = true;
                                            this.planService.updatePhleboPlan(this.editPhleboPlanForm.value).subscribe(

                                                (res: any) => {
                                                    if (res && res.status) {

                                                        this.toastr.success(`${res.message.charAt(0).toUpperCase() + res.message.slice(1)}`);
                                                        this.onCloseNext();
                                                    } else {
                                                        if (res.message) {
                                                            this.toastr.error(`${res.message}`);
                                                        } else {
                                                            this.toastr.error(`submit failed`);
                                                        }
                                                    }
                                                    this.nextSaveBtnLoding = false;
                                                },
                                                (err: any) => {
                                                    this.onClose();
                                                    this.toastr.error(`${err.statusText}`);

                                                    this.phleboTouchSubmit=false;
                                                }
                                            );


                                    } else {
                                        this.showError = true;
                                        this.rosterTouchSubmit=false;
                                    }
                            break;
            case 'viewRosterphlebo':
            this.rosterTouchSubmit=true;
                if (this.rosterForm) {
                   this.rosterForm.get('phlebo_id').setValue(this.data.id);
                    this.showError = false;
                    this.isBtnLoaded = true;
                        this.phleboService.onSaveRoster(this.rosterForm.value,this.data.id).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`submit failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                                this.rosterTouchSubmit=false;
                            }
                        );


                } else {
                    this.showError = true;
                    this.rosterTouchSubmit=false;
                }
                break;
                case 'viewRosterRunner':

                    this.rosterTouchSubmit=true;
                        if (this.rosterFormRunner) {

                           this.rosterFormRunner.get('runner_id').setValue(this.data.id);

                            this.showError = false;
                            this.isBtnLoaded = true;
                                this.runnerService.onSaveRoster(this.rosterFormRunner.value,this.data.id).subscribe(
                                    (res: any) => {
                                        if (res && res.success) {
                                            this.toastr.success(`${res.message}`);
                                            this.onCloseNext();
                                        } else {
                                            if (res.message) {
                                                this.toastr.error(`${res.message}`);
                                            } else {
                                                this.toastr.error(`submit failed`);
                                            }
                                        }
                                        this.isBtnLoaded = false;
                                    },
                                    (err: any) => {
                                        this.onClose();
                                        this.toastr.error(`${err.statusText}`);

                                        this.rosterTouchSubmit=false;
                                    }
                                );


                        } else {
                            this.showError = true;
                            this.rosterTouchSubmit=false;
                        }

        }
    }
       onSaveCompleted() {
                            this.isBtnLoaded = true;
                           this.orderService.saveCompleted(this.data.id).subscribe(
                               (res: any) => {
                                   if (res && res.success) {
                                       this.isBtnLoaded = false;

                                       this.toastr.success(`${res.message}`);
                                       this.onCloseNext();
                                   } else {
                                    this.isBtnLoaded = false;

                                       if (res.message) {
                                           this.toastr.error(`${res.message}`);
                                       } else {
                                           this.toastr.error(`submit failed`);
                                       }
                                   }
                                   this.isBtnLoaded = false;
                               },
                               (err: any) => {
                                   this.onClose();
                                   this.isBtnLoaded = false;

                                   this.toastr.error(`${err.statusText}`);

                               }
                           );




       }
    onSaveDecline() {

        switch (this.type) {
            case 'declineVisit':


                if (this.declineForm) {

                    this.declineForm.get('visit_id').setValue(this.data.id);

                    this.showError = false;
                    this.isBtnLoaded = true;

                        this.orderService.saveDeclineComment(this.declineForm.value).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`submit failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );


                } else {
                    this.showError = true;
                }
                break;

        }
    }



    onAssignTask() {

        switch (this.type) {

            case 'assignTask':

            this.assignTaskTouchSubmit=true;
                if (this.assignForm) {

              this.assignForm.get('task_id').setValue(this.data.id);


                    this.showError = false;
                    this.isBtnLoaded = true;
                        this.taskService.onAssignTask(this.assignForm.value).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onCloseNext();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`submit failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);

                                this.assignTaskTouchSubmit=false;
                            }
                        );


                } else {
                    this.showError = true;
                    this.assignTaskTouchSubmit=false;
                }
                break;

        }
    }
    permissionData(data){
    if(data.target.checked){
       const  index = this.checkedPermission.findIndex(x => x === data.target.value);
        if(!index.length){
            this.checkedPermission.push(data.target.value);
        }
    }else{
        this.checkedPermission.forEach((element,index)=>{
            if(element==data.target.value) this.checkedPermission.splice(index,1);
         });

    }



    }



    get phleboInfo() {
        return this.changeLocationForm.controls;
    }
    get phleboplanInfo() {
        return this.editPhleboPlanForm.controls;
    }
    get visitplanInfo() {
        return this.editVisitPlanForm.controls;
    }

    permissionStore(event){
        if(event.target.checked){
            // Convert event.target.value to a number if it's not already a number
            const value = Number(event.target.value);

        // Check if value is not already in permissionForRole
        if (!this.permissionForRole.includes(value)) {
            this.permissionForRole.push(value);
        }
        }else{
            this.permissionForRole.splice(this.permissionForRole.indexOf(event.target.value),1);
        }

    }

    assignPermission(){

            this.nextSaveBtnLoding = true;
            const rolepermission =
                {
                    role_id:this.data.id,
                    permissions:this.permissionForRole?this.permissionForRole:''
                }
        this.roleService.assignPermission(rolepermission).subscribe(
            (res: any) => {
                if (res && res.success) {
                    this.toastr.success(`${res.message}`);
                    this.nextSaveBtnLoding = false;
                    this.onCloseNext();
                } else {
                    if (res.message) {
                        this.nextSaveBtnLoding = false;
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.nextSaveBtnLoding = false;
                        this.toastr.error(`submit failed`);
                    }
                }
                this.nextSaveBtnLoding = false;
            },
            (err: any) => {
                this.onClose();
                this.toastr.error(`${err.statusText}`);
                this.nextSaveBtnLoding = false;
            }

        );
    }

    insertLab(event,id){

        for (let index = 0; index < this.addlablocation.length; index++) {
            if (this.addlablocation[index].id==id) {
                this.addlablocation[index].lab_location_id = event.value.value;
                this.addlablocation[index].lab_location_name = event.value.text;
            }
        }

    }


  getGeocode(data) {
        switch (data) {
            case 1:
                const address=this.changeLocationForm.value.start_point;
                this.phleboService.getGoogleLatLong(address).subscribe((data) => {
                    this.changeLocationForm.get('start_lat').setValue(data?.data?.lat);
                    this.changeLocationForm.get('start_long').setValue(data?.data?.lng);
                });
                break;
                case 2:
                    const address1=this.changeLocationForm.value.end_point;
                    this.phleboService.getGoogleLatLong(address1).subscribe((data) => {
                        this.changeLocationForm.get('end_lat').setValue(data?.data?.lat);
                        this.changeLocationForm.get('end_long').setValue(data?.data?.lng);
                    });
                    break;
                    case 3:
                        const address2=this.editPhleboPlanForm.value.starting_point;
                        this.phleboService.getGoogleLatLong(address2).subscribe((data) => {
                            this.editPhleboPlanForm.get('start_lat').setValue(data?.data?.lat);
                            this.editPhleboPlanForm.get('start_long').setValue(data?.data?.lng);
                        });
                        break;

                    case 4:
                        const address3=this.editPhleboPlanForm.value.end_point;
                        this.phleboService.getGoogleLatLong(address3).subscribe((data) => {
                            this.editPhleboPlanForm.get('end_lat').setValue(data?.data?.lat);
                            this.editPhleboPlanForm.get('end_long').setValue(data?.data?.lng);
                        });
                        break;

            default:
                break;
        }

    }

    assignRunnerTour() {

        this.ReportTouchSubmit = true;

        if (this.AssignRunnerForm.valid) {
            this.nextSaveBtnLoding = true;
            this.fromDate!==this.assignRunnerData.from_date?this.fromDate.setDate(this.fromDate.getDate() + 1):'';
            this.toDate!==this.assignRunnerData.to_date?this.toDate.setDate(this.toDate.getDate() + 1):'';
            const data = {runner_id:this.AssignRunnerForm.value.runner_id,
                          from_date: this.fromDate,
                          to_date: this.toDate}
            this.TourService.editTour(data, this.data.id).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.toastr.success('Tour Updated Successfully');
                        this.onCloseNext();
                    } else {
                        if (res.message) {
                            this.nextSaveBtnLoding = false;
                            this.toastr.error(`${res.message}`);
                            this.onCloseNext();
                        } else {
                            this.toastr.error(`Phbelo Not Added Successfully`);
                        }
                    }
                },
                (err: any) => {
                    this.toastr.error(`${err}`);

                },
                () => {
                    this.nextSaveBtnLoding = false;
                    this.ReportTouchSubmit = false;
                }
            );
        }
    }

    getLatLongByaddress(){

    }

    assignLabLocation(){
        this.nextSaveBtnLoding =true;
        if (this.addlablocation) {
             const hasMissingLocation = this.addlablocation.some(
            (item) => !item.lab_location_id
        );

        if (hasMissingLocation) {
            this.toastr.error('Please select lab location for all tests.');
            this.nextSaveBtnLoding = false;
            this.isBtnLoaded = false;
            return;
        }



            // for (let index = 0; index < this.addlablocation.length; index++) {
            //   for (let x = 0; x < this.lablocationList.length; x++) {
            //     if(this.addlablocation[index].lab_location_id == this.lablocationList[x].id){
            //         this.addlablocation[index].lab_location_name = this.lablocationList[x].location_name + " - " + this.lablocationList[x].address + " - " + "(" + this.lablocationList[x].location_code + ") ";
            //     }
            //   }
            // }
            // this.declineForm.get('visit_id').setValue(this.data.id);

        this.showError = false;
        this.isBtnLoaded = true;

        this.addlablocation.forEach(addLabLocation => {
        // Find the matching lab location in lablocationList
        const labLoc = this.lablocationList.find(item => item.id === addLabLocation.lab_location_id);
            // console.log(labLoc); return;
            
                    // If the matching lab location is found, set the lab_location_city_id
                    if (labLoc) {
                        addLabLocation.lab_location_city_id = labLoc.city_id;
                        addLabLocation.lab_price = labLoc.price || 0;
                        addLabLocation.lat = labLoc.lat || '';
                        addLabLocation.long = labLoc.long || '';
                    }
                });
                const data = {
                    test:this.addlablocation,
                    main_lab_id: this.mainLabId
                };
                
                this.orderService.addlablocationBytest(data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onCloseNext();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`submit failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.isBtnLoaded = false;
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );

        } else {
            this.nextSaveBtnLoding =false;
            this.showError = true;

        }
    }



    salesRepersentativeProfileChange(event){
      this.salesRepProfileModelData = event.target.files[0]

      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (_event) => {
        this.salesRepProfileData = reader.result;
      }
    }

    salesRepeProfileUpload(){
      if (this.salesRepProfileData) {
        this.showError = false;
        this.isBtnLoaded = true;
            const data = {profile:this.salesRepProfileModelData};
            this.salesService.salesRepProfileUpload(data,this.data.Employee_Id).subscribe(
                (res: any) => {
                    if (res && res.success) {
                        this.toastr.success(`${res.message}`);
                        this.onCloseNext();
                    } else {
                        if (res.message) {
                            this.toastr.error(`${res.message}`);
                        } else {
                            this.toastr.error(`submit failed`);
                        }
                    }
                    this.isBtnLoaded = false;
                },
                (err: any) => {
                    this.onClose();
                    this.toastr.error(`${err.statusText}`);

                }
            );

    } else {
        this.showError = true;

    }
    }

    onMainLabChange(selectedLab: any) {

        this.location_addresslistForDropdown = [];
        this.masterLabLocation = null;
        this.clearLabLocationsFromTable();
        if (!selectedLab) {
            // this.location_addresslistForDropdown = [];
            // this.masterLabLocation = null;
            this.changeMasterLabLocation();
            this.mainLabId = null;
            return;
        }
         const selectedLabId = selectedLab;
         this.mainLabId = selectedLabId;
        // const selectedLabId = selectedLab.value || selectedLab.id;
        let searchQuery = '';
        if (selectedLabId) {
            searchQuery = `lab_id=${selectedLabId}`;
        }

        this.lablocationService.obtainLablocations(searchQuery).subscribe((data) => {
            this.lablocationList = data.data.rows;
            const thisData = [];
            data.data.rows.forEach((item) => {
                thisData.push({ value: item.id, text: item.location_name + ' - ' + item.address + ' - ' + '(' + item.location_code + ') ' });

            });
            this.location_addresslistForDropdown = thisData
            // ✅ Set default lab location if available
            // if (this.defaultLabLocationId) {
            //     const match = this.location_addresslistForDropdown.find(loc => loc.value == this.defaultLabLocationId);
            //     if (match) {
            //         this.masterLabLocation = match;
            //     }
            // }
            if (this.defaultLabLocationId) {
                const match = this.location_addresslistForDropdown.find(
                    loc => loc.value == this.defaultLabLocationId
                );

                if (match) {
                    this.masterLabLocation = match;

                    // ✅ Also apply default to each visitTestsdata row if not already set
                    if (this.visitTestsdata?.length > 0) {
                        this.visitTestsdata.forEach(test => {
                            if (!test.selectedLabLocation) {
                                test.selectedLabLocation = match;
                            }
                        });
                    }
                }
            }


        });

    }
    clearLabLocationsFromTable() {
        this.visitTestsdata.forEach(element => {
            if (element.visit_lab) {
                element.visit_lab.lab_location_id = null;
                element.visit_lab.lab_location_name = null;
            }
        });

        this.addlablocation.forEach(location => {
            location.lab_location_id = null;
            location.lab_location_name = null;
        });
    }
    changeMasterLabLocation(){
        if (!this.masterLabLocation || !this.masterLabLocation.value) {
            this.visitTestsdata.forEach(element => {
                if (element.visit_lab) {
                    element.visit_lab.lab_location_id = null;
                    element.visit_lab.lab_location_name = null;
                }
                for (let index = 0; index < this.addlablocation.length; index++) {
                    if (this.addlablocation[index].id == element.id) {
                        this.addlablocation[index].lab_location_id = null;
                        this.addlablocation[index].lab_location_name = null;
                    }
                }
            });
            return;
        }
        // console.log(this.masterLabLocation.value+  ' Master Location');
        this.visitTestsdata.forEach(element => {
            if(element.visit_lab?.length){
                element.visit_lab.lab_location_name =  this.masterLabLocation.text;
            }else{
                element.visit_lab = {lab_location_id:this.masterLabLocation.value};
                element.visit_lab = {lab_location_name:this.masterLabLocation.text};
            }
            for (let index = 0; index < this.addlablocation.length; index++) {
                if (this.addlablocation[index].id==element.id) {
                    this.addlablocation[index].lab_location_id = this.masterLabLocation.value;
                    this.addlablocation[index].lab_location_name = this.masterLabLocation.text;
                }
            }
        });
    }

    replacePhlebo(value: string): string {
        if (!value) return '';
        return this.isDeviceService ? value.replace(/Phlebo/gi, 'FO') : value;
    }

}
